import img1 from "../../images/rex2.png";
import img2 from "../../images/bra.png";
import img3 from "../../images/diplodocus.png";
import img4 from "../../images/trice.png";
import img5 from "../../images/velociraptor.png";
import img6 from "../../images/stegosaurus.png";
import img7 from "../../images/pte.png";
import img8 from "../../images/epid.png";
import img9 from "../../images/que.png";
import img10 from "../../images/szastaz.png";
import img11 from "../../images/liopleurodon.png";
import img12 from "../../images/mosasaurus.png";

export const homeObjOne = {
  id: "ladowe",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "T-Rex",
  headline: "Tyranozaur",
  description:
    "Nazwa naukowa: Tyrannosaurus, wzrost: 3,7 – 6,1 m, masa: 4 500 – 14 000 kg, szybkość: 27 km/h, długość życia: 30 lat, najstarsze skamieniałości: kreda",
  buttonLabel: "▲",
  imgStart: false,
  img: img1,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "ladowe",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Brachiosaurus",
  headline: "Brachiozaur",
  description:
    "Rodzaj zauropoda z rodziny brachiozaurów (Brachiosauridae), o „żyrafiej” szyi i sylwetce. Jeden z największych i najbardziej znanych roślinożernych dinozaurów. Pokrycie ciała: łuskowata skóra, szyja: długa 7 m do 9,5 m, uzębienie: 52 słabe, przystosowane do zrywania liści zęby, wielkość: - długość: ok. 22–27 m, - wysokość: ok. 13 m, w pasie barkowym 6 m, - masa: pomiędzy 28 a 80 t",
  buttonLabel: "▲",
  imgStart: true,
  img: img2,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjThree = {
  id: "ladowe",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Diplodocus",
  headline: "Diplodok",
  description:
    "Zwierzę żyło na zachodzie Ameryki Północnej pod koniec jury. Należy do najpopularniejszych dinozaurów górnej formacji Morrison złożonej z osadów pochodzących z płytkiego morza i aluwialnych sprzed 150-147 milionów lat (kimeryd i tyton). Diplodocus należy do najłatwiejszych w identyfikacji dinozaurów, ze swym klasycznym zauropodzim kształtem, długą szyją i ogonem oraz czterema nogami o mocnej budowie. Przez wiele lat był najdłuższym znanym dinozaurem. Jego wielkie rozmiary mogły odstraszać drapieżniki, jak allozaur czy ceratozaur, których skamieliny znaleziono w tych samych warstwach, co oznacza, że koegzystowały razem z diplodokiem.",
  buttonLabel: "▲",
  imgStart: false,
  img: img3,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjFour = {
  id: "ladowe",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Triceratops",
  headline: "Triceratops",
  description:
    "Rodzaj roślinożernego dinozaura rogatego z rodziny ceratopsów, żyjącego w mastrychcie (kreda późna), od 68 do 65,5 milionów lat temu na terenach dzisiejszej Ameryki Północnej. Należy do ostatnich nieptasich dinozaurów, które pojawiły się przed wymieraniem kredowym. Nosząc dużą kostną kryzę na szyi i trzy rogi, czworonożny, przypominający pod pewnymi względami nosorożca triceratops stał się jednym z najbardziej rozpoznawalnych dinozaurów i najlepiej znanym przedstawicielem Ceratopsidae.",
  buttonLabel: "▲",
  imgStart: true,
  img: img4,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjFive = {
  id: "ladowe",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Velociraptor",
  headline: "Welociraptor",
  description:
    "Był dwunożnym drapieżnikiem zamieszkującym tereny dzisiejszej Mongolii pod koniec okresu kredy 83 do 70 milionów lat temu. Dinozaury te anatomicznie znacznie bardziej przypominały dzisiejsze ptaki niż gady. Ich kości nadgarstka przypominały kości ptasich skrzydeł. Welociraptory były bardzo szybkie i dosyć zwinne (m.in. dzięki ułatwiającemu manewrowanie usztywnionemu ogonowi).",
  buttonLabel: "▲",
  imgStart: false,
  img: img5,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjSix = {
  id: "ladowe",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Stegosaurus",
  headline: "Stegozaur",
  description:
    "Duży, ciężko zbudowany czworonożny roślinożerca, cechował się charakterystyczną posturą, silnie zaokrąglonym grzbietem, krótkimi przednimi łapami, głową leżącą nisko nad podłożem i usztywnionym ogonem trzymanym wysoko w powietrzu. Jego rzędy płyt i kolce pobudzały naukowców do spekulacji. Te drugie służyły prawdopodobnie do obrony, podczas gdy pierwsze mogły prócz tego pełnić rolę w popisach zwierząt czy w termoregulacji. Rodzaj ten cechował się największymi rozmiarami wśród stegozaurów, osiągając mniej więcej rozmiary autobusu.",
  buttonLabel: "▲",
  imgStart: true,
  img: img6,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjSeven = {
  id: "powietrzne",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Pterodactylus",
  headline: "Pterodaktyl",
  description:
    "Tak jak u wszystkich pterozaurów, jego skrzydła były zbudowane ze skórnej błony rozpiętej między wydłużonym czwartym palcem przedniej kończyny, z rozpiętością wynoszącą co najmniej 1,06 metra. Kształt zębów wskazuje, że pterodaktyl był głównie rybożerny (mięsożerny). Mając czaszkę o długości ok. 20 cm mógł bez trudu zjadać ryby z rodzaju Leptolepides, osiągające zwykle 5–8 cm długości. Mógł on unosić się na powierzchni wody podobnie jak dzisiejsze kaczki i nurkować by łowić ryby. Mógł też latać nisko nad powierzchnią wody i chwytać będące blisko powierzchni ryby bez zanurzania się, albo nurkować podobnie jak dzisiejsze głuptaki czy pelikany.",
  buttonLabel: "▲",
  imgStart: false,
  img: img7,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjEight = {
  id: "powietrzne",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Epidendrosaurus ninchengensis",
  headline: "Epidendrozaur",
  description:
    "Rodzaj teropoda z grupy maniraptorów, z rodziny Scansoriopterygidae. Długość ciała ok. 12-15 cm, wysokość ok. 5 cm, ciężar ok. 100 g. Cechą nietypową tego dinozaura jest niezwykle wydłużony trzeci palec na każdej z kończyn przednich, przy normalnych wymiarach pozostałych dwóch palców.",
  buttonLabel: "▲",
  imgStart: true,
  img: img8,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjNine = {
  id: "powietrzne",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Quetzalcoatlus northropi",
  headline: "Kecalkoatl",
  description:
    "Największe stworzenie latające w historii ziemi. Był drapieżnym dinozaurem latającym, żyjącym w okresie kredy około 6 milionów lat temu. Skamieniałości tego dinozaura odkryto w wykopaliskach na terenie Ameryki Północnej. Rozpiętość skrzydeł wynosiła aż 12 metrów przy wadze jedynie 200 kg. Nie posiadał zębów, a znaleziska wskazują, że mógł się żywić rybami. Budowa ciała wskazuje, że mógł szybować na znaczne odległości.",
  buttonLabel: "▲",
  imgStart: false,
  img: img9,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTen = {
  id: "wodne",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Shastasaurus sikanniensis",
  headline: "Szastazaur",
  description:
    "W pełni dorosły przedstawiciel osiągał 21 metrów długości, masę minimalną określa się na ok. 50000 natomiast maksymalną na 75000 kilogramów.",
  buttonLabel: "▲",
  imgStart: true,
  img: img10,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjEleven = {
  id: "powietrzne",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Liopleurodon",
  headline: "Liopleurodon",
  description:
    "Wielki morski gad drapieżny żyjący na przełomie środkowej i późnej jury (od ok. 165 millionów do 155 millionów lat temu). W swoim czasie największy morski drapieżnik. Liopleurodony miały wielkie głowy, krótkie szyje i raczej dłuższe ciała oraz rozszerzony tył czaszki, gdzie znajdowały się potężne mięśnie szczęk pełnych wielkich zębów.",
  buttonLabel: "▲",
  imgStart: false,
  img: img11,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwelve = {
  id: "wodne",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Mosasaurus",
  headline: "Mozazaur",
  description:
    "Mosasaurus żył w okresie późnej kredy (mastrycht, około 71–66 mln lat temu) na terenach obecnych: Europy (Belgia, Holandia, Szwecja, Polska), Ameryki Północnej (USA; stany Dakota Południowa i New Jersey), Afryki, Nowej Zelandii i być może Japonii. Mógł osiągać ponad 17,5 m długości (u okazu z Penzy sama czaszka mierzyła prawdopodobnie ponad 1,7 m.",
  buttonLabel: "▲",
  imgStart: true,
  img: img12,
  alt: "dinozaur",
  dark: true,
  primary: true,
  darkText: true,
};
